import axios, { AxiosPromise } from 'axios';
import config from '@/config';

export interface TokenResponse {
  'access_token': string;
  'expires_in': number;
  'not-before-policy': number;
  'refresh_expires_in': number;
  'refresh_token': string;
  'scope': string;
  'session_state': string;
  'token_type': string;
}

export function exchangeSsoCode(ssoCode: string): AxiosPromise<TokenResponse> {
  const resource = `${config.api.url}${config.api.endpoints.authentication}/exchange-sso-code`;
  const body = {
    ssoCode
  };
  return axios.post(resource, body, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export async function refreshToken(refreshToken: string): Promise<AxiosPromise<TokenResponse>> {
  const resource = `${config.api.url}${config.api.endpoints.authentication}/token-refresh`;
  const body = {
    refreshToken
  };
  return axios.post(resource, body, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}
export function buildSigninLink(): string {
  const target = `${config.security.ssoUrl}/auth?client_id=${config.security.clientId}&redirect_uri=${config.security.redirectUrl}&${config.security.miscParams}`;
  return target;
}

export function buildLogoutLink(): string {
  const target = `${config.security.ssoUrl}/logout?redirect_uri=${config.security.redirectUrl}`;
  return target;
}
